import titleBackgroundSvg from './title_background.svg';
import './TitleBackground.css';

/** Figma title_background (154:32483) — yellow ribbon behind title. */
export function TitleBackground() {
  return (
    <img
      className="daily-strike-title-background"
      src={titleBackgroundSvg}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
